import AdbTabs from './src/adb-tabs.vue';

AdbTabs.install = function (Vue) {
  Vue.component(AdbTabs.name, AdbTabs);
};

export default AdbTabs;
